export default __webpack_public_path__ + "static/media/kids-and-baby.ca8b110e.png";